import { useWireState, useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import { useOutletContext } from 'react-router-dom'

const OrgBillingViewModel = () => {
    
    const user = useWireValue(store.user)
    const credits = useWireValue(store.credits)
    const [purchaseCreditsDialogOpen, setPurchaseCreditsDialogOpen] = useWireState(store.purchaseCreditsDialogOpen)
    
    const {
        organization,
        organizationError,
        organizationIsLoading,
        fetchOrganization,
    } = useOutletContext()
    
    return {
        
        // Global State
        user,
        credits,
        organization,
        organizationError,
        organizationIsLoading,
        fetchOrganization,
        purchaseCreditsDialogOpen,
        setPurchaseCreditsDialogOpen,
        
    }
    
}

export default OrgBillingViewModel
